import * as React from 'react'
import { Slot } from '@radix-ui/react-slot'
import { cva } from 'class-variance-authority'

import { cn } from '../../lib/utils.js'

const buttonVariants = cva(
  'self-stretch inline-flex items-center justify-center whitespace-nowrap rounded-full text-sm font-medium ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none',
  {
    variants: {
      variant: {
        default:
          'bg-[--brand-500] text-primary-foreground hover:bg-[--brand-700] focus:bg-[--brand-500] disabled:bg-[--neutral-300] text-white',
        destructive: 'bg-destructive text-destructive-foreground hover:bg-destructive/90',
        outlinePrimary:
          'border border-input bg-background hover:bg-[--brand-300] hover:text-accent-foreground border-[--brand-900] text-[--brand-900]',
        outlineSecondary:
          'border border-input border-[--neutral-100] bg-background text-[--neutral-700] hover:bg-[--brand-300] hover:text-accent-foreground',
        secondary: 'bg-secondary text-secondary-foreground hover:bg-secondary/80',
        ghost: 'hover:bg-accent hover:text-accent-foreground',
        link: 'text-[--brand-500] font-semibold disabled:text-[--neutral-300]',
        back: 'text-neutral-700 font-semibold',
      },
      size: {
        default: 'text-base font-semibold h-10 px-4 py-[10px] disabled:text-white',
        sm: 'h-9 rounded-md px-3',
        lg: 'h-11 rounded-md px-8',
        icon: 'h-10 w-10',
        text: 'h-5',
      },
    },
    defaultVariants: {
      variant: 'default',
      size: 'default',
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, isLoading, ...props }, ref) => {
  const Comp = asChild ? Slot : 'button'
  return <Comp data-testid="button" className={cn(buttonVariants({ variant, size, className }))} ref={ref} {...props} />
})
Button.displayName = 'Button'

export { Button, buttonVariants }
